import React from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonContent, IonButton, IonImg, IonFooter, IonHeader } from '@ionic/react';

import { MenuItem_Add } from './AddMenuItem';

import '../../../css/layout.css';

export function MenuModal(props) {

    function closeModalHandler() {

        props.closeModal(false);
    }

    return (
    <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
                <IonHeader  style={{color: "black"}}>
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <h3>MENU</h3>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonHeader>
        <IonContent className='grid_content'>
            <MenuItem_Add closeModal={() => closeModalHandler()} closeModal_update={() => props.closeModal_update ()} data={{
                                        status: props.data.status,
                                        fileLocation: props.data.roomGuestInvoiceAttachment, 
                                        roomID: props.data.roomID, 
                                        roomSalePrice: props.data.roomSalePrice,
                                        invoiceID: props.data.invoiceID,
                                        customerInvoiceID: props.data.customerInvoiceID,
                                        }}></MenuItem_Add>

        </IonContent>
        <IonFooter className='grid_footer'>
            <IonGrid>
                <IonRow>
                    <IonCol>
                        <IonButton onClick={closeModalHandler}> Close </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonFooter>
        </IonModal>) : null}
    </React.Fragment>
    )
}